import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'ordinazione al tavolo',
    [ORDER_METHODS.PICKUP]: 'ritiro',
    [ORDER_METHODS.DELIVERY]: 'consegna',
  },
  errors: {
    draft_validation_failed: "Completa l'indirizzo di consegna prima di continuare.",
  },
};
